import type EnType from '../en-US/api';

export default {
  'api.label.authorization.inheritLabel': 'Ver autorización {type} de esta API',
  'api.label.authorization.inheritLabel.folder': 'Heredado del grupo [{folderName}]',
  'api.label.authorization.inheritLabel.project': 'Heredado del proyecto',

  'api.label.authorization.description.apikey':
    'Agregar parámetro en {position} <div class="locals-tag">{key}</div>',
  'api.label.authorization.description.bearer':
    'Proporciona tu token bearer en el encabezado <div class="locals-tag">Authorization</div> al realizar solicitudes a recursos protegidos.',
  'api.label.authorization.description.basic':
    'Envía tus solicitudes HTTP con un encabezado <div class="locals-tag">Authorization</div> que contenga la palabra Basic seguida de un espacio y una cadena codificada en base64 <span class="ui-tag whitespace-normal break-all"><code>username:password</code></span>',
  'api.label.authorization.description.digest':
    'Proporciona tus datos de esquema de digest encriptado en el encabezado <div class="locals-tag">Authorization</div> al realizar solicitudes a recursos protegidos.',
  'api.label.authorization.description.hawk':
    'Proporciona tus datos de esquema Hawk encriptado en el encabezado <div class="locals-tag">Authorization</div> al realizar solicitudes a recursos protegidos.',
  'api.label.authorization.description.aws':
    'Agregar parámetros <div class="locals-tag">Authorization</div> y <div class="locals-tag">X-Amz-Date</div> al Encabezado',
  'api.label.authorization.description.aws.url':
    'Agregar parámetros <div class="locals-tag">Authorization</div> info y <div class="locals-tag">X-Amz-Date</div> en la URL',
  'api.label.authorization.description.edgegrid':
    'Agregar el parámetro <div class="locals-tag">Authorization</div> al Encabezado, cuyo valor es concatenar el esquema de encriptación digest después de EG1-HMAC-SHA256',

  'api.label.authorization': 'Autorización',
  'api.label.parameters': 'Solicitud',
  'api.label.codeSample': 'Ejemplos de solicitud',
  'api.label.responses': 'Respuestas',
  'api.label.example': 'Ejemplo',
  'api.label.callbacks': 'Callbacks',
  'api.label.dataSchema': 'Schemas',
  'api.auth.label.addAuthDataTo': 'Agregar a',
  'api.auth.label.addTo': 'Agregar a',
  'api.auth.label.more': 'Avanzado',
  'api.auth.label.moreTip':
    'Estas son opciones de configuración avanzadas. Son opcionales. {appName} generará automáticamente valores para algunos campos si se dejan en blanco.',
  'api.auth.label.disableRetryRequest': 'Deshabilitar reintento de la solicitud',
  'api.auth.label.disableRetryRequestTip':
    'Por defecto, {appName} extraerá valores de la respuesta recibida, los agregará a la solicitud y la reintentará. ¿Quieres deshabilitar esto?',
  'api.parameterLabel.name': 'Nombre',
  'message.bodyParameter': 'Parámetros del Body  ',
  'api.parameterLabel.value': 'Valor',
  'api.parameterLabel.example': 'Ejemplo',
  'api.parameterLabel.type': 'Tipo',
  'api.parameterLabel.noNeedToDefineTheBody': 'No es necesario definir el Body',
  'api.parameterLabel.noNeedToDefineTheResponse': 'No es necesario definir la Respuesta',
  'message.hasNoResponseBody': 'Esta respuesta no tiene un body.',
  'api.parameterLabel.file.disabled.tip':
    'El tipo de archivo no es compatible cuando el Body es x-www-form-urlencode, por favor usa form-data en su lugar',
  'api.status.designing': 'Diseñando',
  'api.status.pending': 'Pendiente',
  'api.status.developing': 'Desarrollando',
  'api.status.integrating': 'Integrando',
  'api.status.testing': 'Probando',
  'api.status.tested': 'Probado',
  'api.status.released': 'Lanzado',
  'api.status.deprecated': 'Deprecado',
  'api.status.exception': 'Excepción',
  'api.status.obsolete': 'Obsoleto',
  'api.automaticGenerated': ' Auto-generar',
  'response.label.headers': 'Encabezados',
  'response.label.body': 'Body',
  'response.label.contentType': 'Tipo de Contenido ',
  'quickDebug.placeHolder.error': 'Formato de URL Incorrecto , {detail}',
  'quickDebug.placeHolder.detail': 'Escribe la URL completa comenzando con http o https',
  'message.queryParameter': 'Parámetros de Query',
  'message.pathParameter': 'Parámetros de Path',
  'message.headerParameter': 'Parámetros de Header',
  'message.cookieParameter': 'Parámetros de Cookie',
  'message.hasNoBodyParameter': "Esta solicitud no tiene construcción de 'body'",
  'api.auth.beginnerTips':
    'La autorización agregada aquí se aplicará a todas las solicitudes bajo este grupo y puede ser modificada dentro de solicitudes específicas',
  'api.auth.label.type': 'Tipo',
  'parameter.count.none': 'Ninguno',
  'api.requestBody.binary.uploaded': 'Archivo Subido',
  'api.requestBody.binary.notConfigured': 'No configurado',
  'api.request.auth.jwt.algorithm.label': 'Algoritmo',
  'api.request.auth.jwt.secret.label': 'Secreto',
  'api.request.auth.jwt.isSecretBase64Encoded.label': 'El secreto está codificado en Base64',
  'api.request.auth.jwt.payload.label': 'Payload',
  'api.request.auth.jwt.headerPrefix.label': 'Prefijo de Autorización HTTP',
  'api.request.auth.jwt.header.label': 'Header JWT Personalizado',
  'api.request.auth.jwt.privateKey.label': 'Clave Privada',
  'api.request.auth.jwt.privateKey.button.label': 'Elegir Archivo',
  'api.request.auth.jwt.queryParamKey.label': 'Nombre del Parámetro de Query',
  'api.request.auth.jwt.algorithm.placeholder': 'Por favor selecciona un algoritmo',
  'api.request.auth.jwt.secret.placeholder': 'Secreto',
  'api.request.auth.jwt.payload.placeholder': 'Componer con JSON',
  'api.request.auth.jwt.headerPrefix.placeholder': 'Prefijo de Autorización HTTP',
  'api.request.auth.jwt.header.placeholder': 'Componer con JSON',
  'api.request.auth.jwt.privateKey.placeholder':
    '-----BEGIN PRIVATE KEY-----\nClave privada en formato PKCS#8 PEM\n-----END PRIVATE KEY-----',
  'api.request.auth.jwt.queryParamKey.placeholder': 'Nombre del Parámetro de Query',
  'api.label.authorization.jwt.description1':
    'Agregar el parámetro <div class="locals-tag">{name}</div> a {addTokenTo}',
  'api.label.authorization.jwt.description2':
    '，cuyo valor es concatenar el Token después del {headerPrefix}.',

  'api.label.authorization.oauth2.httpAuthorizationPrefix.label': 'Prefijo de Autorización HTTP',
  'api.label.authorization.oauth2.grantType.label': 'Tipo de Concesión',
  'api.parameterLabel.contentType': 'Content-Type',
  'modified.at.label': 'Modificado en',
  'built.with': 'Construido con',
  slogan: 'Plataforma API Todo en Uno: Diseñar, Depurar, Mock, Probar y Documentar',
  'doc.anchor.title': 'En esta página',
  'http.status.code.tooltip': 'Código de Estado HTTP',
  examples: 'Ejemplos',
  'api.auth.securitySchemeUseCase.valueAssignment.inherit.title': 'Usar Valores de Auth Predeterminados del Padre',
  'api.auth.securitySchemeUseCase.valueAssignment.inherit.desc':
    'Usar los valores de auth predeterminados configurados en la carpeta padre.',
  'api.auth.securitySchemeUseCase.valueAssignment.override.title': 'Establecer Manualmente',
  'api.auth.securitySchemeUseCase.valueAssignment.override.desc':
    'Configurar manualmente los valores requeridos para la autorización.',
  'api.auth.folderSecuritySchemeUseCase.defaultValue': 'Valores de Auth Predeterminados',
  'api.auth.securitySchemeDefinition.more':
    '{count, plural, one {Y {count, number} otro.} other {Y {count, number} otros.}}',
  'api.auth.securitySchemeDefinition.notToAuth': 'No Autenticar',
  'api.auth.securitySchemeUseCase.valueIn': 'En {in}',
  'api.label.sourceUrl': ' Enlace original',
  'api.label.operationId': 'OperationId',
  'api.customAuth.error.message.title': 'Error',
  'api.customAuth.redirect.title': 'Redirigiendo...',
  'api.action.mcp.modal.description':
    'Permitir que las herramientas de IA accedan al sitio completo de documentación de API para codificación asistida por IA.',
  'api.action.mcp.modal.editor.other': 'Otros',
  'api.action.mcp.modal.cursor.copy': 'Configuración de un clic',
  'api.action.mcp.modal.cursor.or': 'o',
  'api.action.mcp.modal.cursor.manualCopy': 'Configuración manual',
  'api.action.mcp.modal.cursor.button.text': 'Haz clic aquí para agregar a Cursor',
  'api.action.mcp.modal.cursor.version': 'Solo admite Cursor versión 1.0 y superior',
  'api.action.mcp.modal.commandTip': 'Nota: El entorno Node.js debe estar instalado (versión >= 18)',
  'api.action.mcp.modal.footer.question': '¿Cómo usar MCP después de copiar el JSON?',
  'api.action.mcp.modal.footer.help': 'Ver documentación de ayuda',
  'api.action.mcp.modal.command.doc': 'Documentación de API',
}satisfies typeof EnType;
